import { makeStyles, Skeleton, SkeletonItem } from "@fluentui/react-components";
import * as React from "react";

const useStyles = makeStyles({
  skeleton: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  dialogSubtitle: {
    width: "80%",
  },

  listTitle: {
    width: "50%",
  },

  listItem: {
    width: "100%",
  },
});

const textSkeletonSize = 20;
const listItemSkeletonSize = 24;

export const SharedPromptsContentSkeleton: React.FC = () => {
  const styles = useStyles();
  return (
    <Skeleton aria-label="Loading Content" className={styles.skeleton}>
      {/* dialog's subtitle */}
      <SkeletonItem className={styles.dialogSubtitle} size={textSkeletonSize} />

      {/* list's title */}
      <SkeletonItem className={styles.listTitle} size={textSkeletonSize} />

      {/* 4 list items */}
      <SkeletonItem className={styles.listItem} size={listItemSkeletonSize} />
      <SkeletonItem className={styles.listItem} size={listItemSkeletonSize} />
      <SkeletonItem className={styles.listItem} size={listItemSkeletonSize} />
      <SkeletonItem className={styles.listItem} size={listItemSkeletonSize} />
    </Skeleton>
  );
};
